module.exports = __webpack_public_path__ + "img/error_w.3b02f016.png";